<template>
  <div class="timeslot">
    <div>
      <!--
      <ui-radio :disabled="(timeslot.content || !computeUserAccess ||disabled)" :greyoutDisabled="computeGreyDisabled" :val="timeslot.id" :selected="timeslot.content"  :key="timeslot.content">
        <b>{{timeslot.time}}</b>
      </ui-radio>
      -->
      <div>
       
        <div class="time">
          <ui-icon class="check-icon" :class="{'has-selected':(selected_child_id>-1)}" background-color="transparent" color="#8cc63e" icon="check"></ui-icon>
          {{timeslot.time}}
        </div>
       
       
        <select class="my-select" v-if="computeUserAccess" :class="{'active':timeslot.child_id>-1}" :disabled="timeslot.content!='' && !timeslot.owner" v-model="selected_child_id" @change="selectChild()">
          <option selected value="-1">
            {{$t('language.select_child')}}
            </option>
          <option v-for="child in children" v-bind:value="child.id" :key="child.id">{{decodeHtml(child.name)}}</option>
        </select>
      </div>
      
    </div>
    <!--
    <div ref="chip">
      <ui-chip v-if="timeslot.owner"  class="chip"  backgroundColor="#8cc63e" @click.native="clickDelete(timeslot.id)" icon="trash-alt">{{timeslot.content}}</ui-chip>
    </div>
    -->
    <div v-if="!timeslot.owner" class="subtitle">{{decodeHtml(timeslot.content)}}</div>
  </div>
</template>

<script>

import { mapState } from 'vuex';
//import UiRadio from '../../components/UiRadio.vue';
import UiIcon from '../../components/UiIcon.vue';

import { USER_LEVEL } from '../../settings/USER_LEVEL';
//import anime from 'animejs/lib/anime.es.js';
//import { modalService } from '../../services/ModalService.js';
//import i18n from "../../language.js";
import { helper } from '../../services/Helper.js';

export default {
  name: 'time-slot',
  props:{
    disabled:{default:false},
    timeslot:{type:Object, default:()=>{return {}} },
    children:{type:Array, default:()=>{return []} },
  },
  data(){
    return {
      //chip:undefined,
      //select_text="language.select_child",
      selected_child_id:this.timeslot.child_id,
    }
  },
  computed:{
     ...mapState(['teacher_talks_slots','appSettings']),
     computeUserAccess(){
         if (this.appSettings.user_level==USER_LEVEL.PARENT){
           return true;
         }
         if (this.appSettings.user_level==USER_LEVEL.TEACHER){
           return false;
         }
         if (this.appSettings.user_level==USER_LEVEL.STUDENT){
           return false;
         }
         if (this.appSettings.user_level==USER_LEVEL.ADMIN){
           return false;
         }
         return false;
       },
       
       computeGreyDisabled(){
         // if not timeslot owner then greyout if disabled
         if(!this.timeslot.owner){
           return true;
         }
         return false
       }
  },
  components:{
   // UiRadio,
    //UiChip,
    UiIcon,
  },
  methods:{
    decodeHtml(html){
      return helper.decodeHtml(html);
    },
    selectChild(){
      
      var childId=this.selected_child_id;
      // emit amongst siblings
      //this.$root.$emit('CLEAN_SELECTED_CHILD',{id:childId});
     

      this.selected_child_id=childId;

      this.$emit('input',{slot_id:this.timeslot.id,child_id:childId});
      //alert("choosen child with id::"+childId)
    },
    tst(){
      console.log("cleaning")
    },
    cleanSelectedChild(data){

      if(data.id==this.selected_child_id){
         this.selected_child_id=-1;
      }
     
    },
    /*
    clickDelete(){
    
     if(this.disabled){
       return;
     }
    
     modalService.createModal(i18n.t('language.delete_talkslot_sure')).then(
        ()=>{ 
          //this.animateHide(slot_id);
          this.emitClickDelete();
        }
      );
     
    },
    */
    /*
    animateShow(){

      this.chip.style.transform="scale(0)";
      this.chip.style.opacity="0";
      anime({
          targets: this.chip,
          opacity:1,
          scale:1,
          duration:350,
          easing: 'easeOutElastic',
        }).finished.then(()=>{
          
        })
      
    },
    animateHide(slot_id){

      

      this.chip.style.transform="scale(1)";
      this.chip.style.opacity="1";
      anime({
          targets: this.chip,
          opacity:0,
          scale:0,
          duration:350,
          easing: 'easeInElastic',
        }).finished.then(()=>{
          
          this.emitDelete(slot_id);
        })
      
    },
    */
    /*
    emitDelete(){
      //this.$emit('deleteSlot',slot_id);
    },
    emitClickDelete(){
      //this.$emit('clickDelete');
    }
    */
    //emitUpdate(){
    //  this.$emit('updateSlots');
    //}
   
    
  },
  updated(){
    console.log("*** UPDATED SLOT ****")
  },
  mounted(){
    this.$parent.$on('input',this.tst);
    //this.chip=this.$refs['chip'];
    //this.animateShow();
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.timeslot{
  margin-bottom:10px;
  text-align:center;
  min-height:95px;
}
.subtitle{
  
  text-align:center;
}
.chip{
  text-align:center;
  cursor:pointer;
  
}
.time{
  font-weight:bold;
}

.my-select{
  height:32px!important;
  border: 1px solid grey;
  padding: 8px;
  border-radius: 4px;
  width:100%;
  text-align:center;
  background-color:#FFFFFF;
  color:#000000;
  transition: all .25s;
  -webkit-appearance:none;
  
}


.my-select:disabled{
  background-color:#E0E0E0;
}


.my-select:focus{
  outline:none;
}

.check-icon{
  opacity:0;
  transition:opacity .25s;
}
.has-selected{
   opacity:1;
}

.subtitle:after{
  content:"\00a0"; /* &nbsp */
}

.active{
  background-color:#8cc63e;
  color:#FFFFFF;
  font-weight:bold;
  
}
</style>
